import { DynamicFormElementConfig } from '../dynamic-form-element';
import { DynamicFormGroupConfig } from '../dynamic-form-group';
import { DynamicFormFieldConfig } from '../dynamic-form-field';

export class DynamicFormArrayConfig extends DynamicFormElementConfig {
  public children: DynamicFormElementConfig[] = [];
  public childPrototypeConfig!: DynamicFormGroupConfig | DynamicFormFieldConfig;
}
